/**
 * Vocabulário visual da saúde de um pedido — compartilhado pela LISTA
 * (`/payments`, veredito por linha vindo de orderHealth.js) e pelo DETALHE
 * (`/payments/order/:id`, motor completo orderAnalysis.js).
 *
 * Mora aqui porque os dois precisam dizer a MESMA coisa com a MESMA cor: um
 * pedido marcado "Atenção" na lista tem de abrir como "ATENÇÃO", e não como
 * amarelo num lugar e laranja no outro.
 */

/** Estado de uma dimensão (ou o pior deles). Chaves = severidades do backend. */
export const HEALTH_STATE_BADGE = {
    critical: { variant: 'danger', label: 'Problema' },
    warn: { variant: 'warning', label: 'Atenção' },
    pending: { variant: 'neutral', label: 'Aguardando' },
    info: { variant: 'info', label: 'Info' },
    ok: { variant: 'success', label: 'OK' },
    // Só a lista usa: dimensão que aquela consulta não avalia. Nunca é um
    // julgamento — é a ausência de um.
    unchecked: { variant: 'neutral', label: 'não checado' },
};

export const HEALTH_DIMENSION_LABELS = {
    COMERCIAL: 'Venda',
    PAGAMENTO: 'Pagamento',
    LIQUIDACAO: 'Recebimento',
    FISCAL: 'Fiscal',
    LOGISTICA: 'Logística',
};

/** Veredito do DETALHE (analysis.health.overall). */
export const HEALTH_OVERALL_LABELS = {
    critical: 'PROBLEMA',
    warn: 'ATENÇÃO',
    pending: 'EM ANDAMENTO',
    info: 'OK',
    ok: 'CONCLUÍDO OK',
};

/** Veredito da LISTA (row.health.status) — três estados, ver orderHealth.js. */
export const LIST_HEALTH_LABELS = {
    attention: 'Atenção',
    pending: 'Aguardando',
    ok: 'OK',
};

/** Opções do filtro por veredito. O valor vai cru no wire (`?health=`). */
export const LIST_HEALTH_FILTERS = [
    { value: '', label: 'Todos os pedidos' },
    { value: 'attention', label: 'Só com atenção' },
    { value: 'pending', label: 'Só aguardando dados' },
    { value: 'ok', label: 'Só OK' },
];
